import { useMemo } from "react";
import { useTranslatedColumns } from "../../../general/modules/commons/tableTranslation/translatedColumns";
import { TireSetTableColumns } from "../../domain/columns/tireSetTableColumns";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { updateTiresetPosition } from "../slices/tireSetMutateSlice";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export const useTireSetsTableColumns = () => {
  const translatedColumns = useTranslatedColumns(TireSetTableColumns);
  const dispatch = useAppDispatch();
  const { hasRole } = useAuthorization();

  const handleUpdatePosition = (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    row: Row<{ [p: object]: unknown }>,
    value: unknown,
  ): void => {
    try {
      const original = row.original as {
        id: string | number;
      };

      void dispatch(
        updateTiresetPosition({
          position_id: value as number,
          id: original?.id,
        }),
      );
    } catch (error) {
      console.error("Error during position update:", error);
    }
  };

  return useMemo(() => {
    const updatedColumns = [...translatedColumns];
    const positionColumnIndex = updatedColumns.findIndex(
      (column) => column.id === "position.id",
    );

    if (positionColumnIndex !== -1) {
      if (hasRole("dbh-manager") || hasRole("super-admin")) {
        updatedColumns[positionColumnIndex] = {
          ...updatedColumns[positionColumnIndex],
          meta: {
            ...updatedColumns[positionColumnIndex].meta,
            columnAction: "disabled",
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            updateData: handleUpdatePosition,
          },
        };
      } else if (hasRole("dealer-employee")) {
        updatedColumns.splice(positionColumnIndex, 1);
      }
    }

    return updatedColumns;
  }, [translatedColumns, hasRole, dispatch]);
};
